import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import CarePlanService from "../../Services/CarePlanService";
import moment from "moment/moment";
import { message, Modal } from "antd";
import { IoCloseCircleSharp } from "react-icons/io5";
import { IoIosCheckmarkCircle } from "react-icons/io";

function CarePlanActivity({ selectedDate }) {
  const patJson = localStorage.getItem("patientData");
  const patObj = patJson ? JSON.parse(patJson) : null;
  const [tasks, setTasks] = useState([]);
  const [createdTask, setCreatedTask] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingTaskId, setEditingTaskId] = useState(null);

  const formatToReadableDate = (isoDateString) => {
    return dayjs(isoDateString).format("dddd D MMMM YYYY");
  };

  const getPatientTask = async () => {
    let payload = {
      patientId: patObj?.patientId,
      fromDate: dayjs(selectedDate).format("MM/DD/YYYY"),
    };

    try {
      let result = await CarePlanService.GetPatientTask(payload);
      setTasks(result.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getPatientTask();
  }, [selectedDate]);

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes()
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  const handleCreateTaskPost = async (task, type) => {
    let payload = [
      {
        createdBy: task?.userId,
        createdDate: task?.createdDate,
        description: task?.taskDescription,
        endCreatedTime: convertUTCDate(selectedDate, "YYYY-MM-DD HH:mm:ss"),
        frequencyCode: task?.frequencyCode,
        frequencyName: null,
        givenDate: dayjs(selectedDate)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"),
        modifiedBy: patObj?.patientId,
        modifiedDate: convertUTCDate(selectedDate, "YYYY-MM-DD HH:mm:ss"),
        enteredDate: dayjs(selectedDate).format("MM/DD/YYYY"),
        enteredOn: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        patientId: patObj?.patientId,
        startCreatedTime: convertUTCDate(selectedDate, "YYYY-MM-DD HH:mm:ss"),
        status: 1,
        taskCode: task?.taskCode,
        taskName: task?.taskName,
        taskTaken: type,
        account_Id: task?.account_Id,
        clinic_Id: task?.clinic_Id,
        userId: task?.userId,
        // patientTaskId: task?.id,
      },
    ];

    try {
      let result = await CarePlanService.UpdateActivityStatus(payload);
      message.success("Activity task update successfully");
      setEditingTaskId(null);
      getPatientTask();
    } catch (err) {
      console.error("error");
    }
  };

  return (
    <div className="max-h-[200px] overflow-y-auto">
      <div className="flex gap-2 mt-3 px-3">
        <span className="font-bold text-sm font-inter">
          {formatToReadableDate(selectedDate)}
        </span>
      </div>
      <hr className="mt-2" />
      <div className="p-4 space-y-4">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 gap-3 max-h-[100px] overflow-y-auto scrollWidth pr-2">
          {tasks &&
            tasks.map((task, index) => {
              const isEditing = editingTaskId === task.id;

              return (
                <div
                  key={index}
                  className="border rounded-lg shadow-sm p-3 bg-white h-full w-full"
                >
                  <h4 className="text-sm font-medium mb-2 text-[#189FAA]">
                    {task.taskName}
                  </h4>
                  <div className="flex text-sm text-gray-600 mb-2">
                    <span>{task.taskDescription}</span>
                  </div>

                  {/* TASK LOGIC */}
                  {task.taskTaken === "NA" || isEditing ? (
                    <div className="flex items-center justify-between">
                      <span className="text-sm font-inter font-medium text-gray-700">
                        Task Completed?
                      </span>
                      <div className="flex gap-1">
                        <button
                          onClick={() => handleCreateTaskPost(task, "N")}
                          className="px-4 py-1 rounded-md text-sm text-gray-600 hover:bg-gray-100"
                        >
                          No
                        </button>
                        <button
                          onClick={() => handleCreateTaskPost(task, "Y")}
                          className="px-4 py-1 bg-[#00a0c8] text-white rounded-md text-sm hover:bg-[#008bb0]"
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  ) : task.taskTaken === "Y" || task.taskTaken === "N" ? (
                    <div className="flex items-center justify-between">
                      <span
                        className={`text-xs font-inter font-semibold flex items-center gap-1 ${
                          task.taskTaken === "Y"
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                      >
                        {task.taskTaken === "Y" ? (
                          <>
                            <IoIosCheckmarkCircle className="text-green-600 w-4 h-4" />{" "}
                            Completed
                          </>
                        ) : (
                          <>
                      <IoCloseCircleSharp className="text-red-600 w-4 h-4" />
                            Not Completed
                          </>
                        )}
                      </span>
                      <button
                        onClick={() => setEditingTaskId(task.id)}
                        className="px-3 py-1 text-xs font-semibold underline cursor-pointer text-[#00a0c8]"
                      >
                        Change
                      </button>
                    </div>
                  ) : null}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default CarePlanActivity;
